<span *ngIf="isMetaState" class="see-more">
  <span class="tag-meta" *ngIf="isTagMetaGenerated">
    <span  class="generated-meta"
      (click)="$event.preventDefault();$event.stopPropagation();onMeta()">
      <img *ngIf="seeMore?.fileCode" class="box-24" [src]="seeMore?.fileCode" alt="icon"
        onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'">
      <img *ngIf="seeMore?.fileCode === '' && isTagMetaGenerated" class="box-24" src="assets/themes/icons/user-profile-placeholder.svg" alt="icon">
      <span class="primary-small fnt-size9px">
        {{seeMore?.fullName}}
      </span>
    </span>
  </span>
  <span class="deeplink-meta" *ngIf="!isTagMetaGenerated"  (click)="$event.preventDefault();$event.stopPropagation();onMeta($event)">
    <span class="primary-small fnt-size12px" *ngIf="!isTagMetaGenerated">
      {{viewPostText}}
    </span>
    <img  src="assets/images/greater.svg" width="15px" alt="icon">
  </span>
</span>
